// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"670":"8a0b08a0","983":"1fbbd2de"}[chunkId] + ".chunk.css";
};